import React,{Suspense} from "react";
import { Routes,Route } from 'react-router-dom'
import Login from "../../views/Login/Login";
import PasswordRecovery from "../../views/Login/PasswordRecovery";
import Bienestar from "../AuthRoutes/Bienestar/Bienestar";
import HealthTracker from "../../views/Bienestar/HealthTracker";

const GuestRoutes = () => {
    return (
        <Routes>
            <Route exact path="/" element={<Suspense fallback={<>skeleton</>}>
                <Login/>
            </Suspense>} />
            <Route exact path="/recovery" element={<Suspense fallback={<>skeleton</>}>
                <PasswordRecovery/>
            </Suspense>} />
            <Route exact path="/bienestar" element={<Suspense fallback={<>skeleton</>}>
                <HealthTracker/>
            </Suspense>} />
            <Route exact path="/*" element={<Suspense fallback={<>skeleton</>}>
                <Login/>
            </Suspense>} />
        </Routes>
    )
}

export default GuestRoutes